import * as Joi from 'joi';

const openPeriodSchema = Joi.object({
  startDate: Joi.string().required().messages({
    'string.empty': 'Start Date not allowed to be empty.',
    'any.required': 'Start Date not allowed to be empty.',
    'date.max': 'Start Date should not be greater than 31/12/2037',
  }),
  startTime: Joi.string()
    .regex(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/)
    .required()
    .messages({
      'string.empty': 'Start Time not allowed to be empty',
      'any.required': 'Start Time not allowed to be empty',
    }),
  endDate: Joi.string().required().messages({
    'string.empty': 'End Date not allowed to be empty.',
    'any.required': 'End Date not allowed to be empty.',
    'date.min': 'End Date should be greater than Start Date',
    'date.max': 'End Date should not be greater than 31/12/2037',
  }),
  endTime: Joi.string()
    .regex(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/)
    .required()
    .messages({
      'string.empty': 'End Time not allowed to be empty',
      'any.required': 'End Time not allowed to be empty',
      'string.any': 'Test',
    }),
});

export default openPeriodSchema;
